import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import { OperatorType } from 'app/modules/collection/services/filter.service';
import { DataSourceFilter } from 'app/providers/bridge-api/dashboard.service';

@Component({
  selector: 'app-dashboard-datasource-filter-pill',
  standalone: true,
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './dashboard-datasource-filter-pill.component.html',
  styleUrl: './dashboard-datasource-filter-pill.component.scss',
})
export class DashboardDatasourceFilterPillComponent {
  @Input() dsFilter: DataSourceFilter;
  @Input() isReadOnly: boolean;
  @Output() dsFilterAction = new EventEmitter<{ filterAction: OperatorType | 'remove' }>();
  pillIcon: string;
  pillTooltip: string;
  filterOptions: DropdownObject[] = [];

  pillText: string;
  translations: any;
  constructor(private transloco: TranslocoService) {}

  ngOnInit() {
    this.translations = this.transloco.translateObject('dashboard-datasource-rules-filter-pill');
    this.pillText = this.dsFilter.label;
    this.pillTooltip = this.getPillTooltip(this.dsFilter);

    this.filterOptions = [
      {
        title: this.translations['move'],
        id: 'move',
        submenu: [
          {
            title: this.translations['all'],
            id: 'and',
          },
          { title: this.translations['any'], id: 'or' },
          { title: this.translations['none'], id: 'not' },
        ],
      },
      { title: this.translations['remove'], id: 'remove' },
    ];

    this.pillIcon = this.getPillIcon();
  }

  private getPillTooltip(dsFilter: DataSourceFilter) {
    if (dsFilter.type === 'date') {
      return `${this.translations['data-field']}: ${dsFilter.label} \n${this.translations['value']}: ${dsFilter.displayValue}`;
    }
    return `${this.translations['data-field']}: ${this.getPillFieldLabel(dsFilter)} \n${
      this.translations['value']
    }: ${dsFilter.label}`;
  }

  private getPillFieldLabel(dsFilter: DataSourceFilter) {
    switch (dsFilter.type) {
      case 'contentChannel':
        return this.translations['content-channel'];
      case 'dataSourceType':
        return this.translations['data-source-type'];
      case 'specificDataSource':
        return this.translations['specific-data-source'];
      case 'label':
        return this.translations['label'];
    }
  }

  private getPillIcon() {
    switch (this.dsFilter.type) {
      case 'contentChannel':
        return 'funnel_chart';
      case 'dataSourceType':
        return 'document_multiple';
      case 'specificDataSource':
        return 'document_report';
      case 'date':
        return 'calendar';
      case 'label':
        return 'tag';
    }
  }

  onPillAction(id: OperatorType | 'remove') {
    this.dsFilterAction.emit({ filterAction: id });
  }
}
